import { forwardRef } from 'react';

import classNames from 'classnames';

import styles from './Flex.module.css';

import type { BoxProps } from '../Box';
import { Box } from '../Box';
import { getStyles } from './getStyles';
import type { FlexResponsiveProps } from './types';

/**
 * Use the `Flex` component to create a flex container to align and distribute
 * space between items in a row or column.
 *
 * @see https://corgi-x.tfd.engineering/components/flex
 */
export const Flex = forwardRef<HTMLDivElement, BoxProps & FlexResponsiveProps>(
  (props, ref) => {
    const {
      className,
      children,
      direction,
      justify,
      alignItems,
      alignContent,
      wrap,
      gap,
      rowGap,
      columnGap,

      ...boxProps
    } = props;

    const flexStyles = getStyles(props);
    const cssClasses = classNames([styles.flex, flexStyles, className]);

    return (
      <Box {...boxProps} ref={ref} className={cssClasses}>
        {children}
      </Box>
    );
  }
);

Flex.displayName = 'Flex';

export type FlexProps = Parameters<typeof Flex>[0];
